// LIST
export const FETCH_LOCATION_BLOGS = "app/LocationBlogs/FETCH_LOCATION_BLOGS";
export const FETCH_LOCATION_BLOGS_SUCCESS =
  "app/LocationBlogs/FETCH_LOCATION_BLOGS_SUCCESS";
export const FETCH_LOCATION_BLOGS_FAILURE =
  "app/LocationBlogs/FETCH_LOCATION_BLOGS_FAILURE";

// GET VIEW DATA
export const GET_VIEW_DATA = "app/LocationBlogs/GET_VIEW_DATA";
export const GET_VIEW_DATA_SUCCESS = "app/LocationBlogs/GET_VIEW_DATA_SUCCESS";
export const GET_VIEW_DATA_FAILURE = "app/LocationBlogs/GET_VIEW_DATA_FAILURE";
// ADD
export const ADD_LOCATION_BLOGS = "app/LocationBlogs/ADD_LOCATION_BLOGS";
export const ADD_LOCATION_BLOGS_SUCCESS =
  "app/LocationBlogs/ADD_LOCATION_BLOGS_SUCCESS";
export const ADD_LOCATION_BLOGS_FAILURE =
  "app/LocationBlogs/ADD_LOCATION_BLOGS_FAILURE";
// EDIT
export const EDIT_LOCATION_BLOGS = "app/LocationBlogs/EDIT_LOCATION_BLOGS";
export const EDIT_LOCATION_BLOGS_SUCCESS =
  "app/LocationBlogs/EDIT_LOCATION_BLOGS_SUCCESS";
export const EDIT_LOCATION_BLOGS_FAILURE =
  "app/LocationBlogs/EDIT_LOCATION_BLOGS_FAILURE";
// DELETE
export const DELETE_LOCATION_BLOGS = "app/LocationBlogs/DELETE_LOCATION_BLOGS";
export const DELETE_LOCATION_BLOGS_SUCCESS =
  "app/LocationBlogs/DELETE_LOCATION_BLOGS_SUCCESS";
export const DELETE_LOCATION_BLOGS_FAILURE =
  "app/LocationBlogs/DELETE_LOCATION_BLOGS_FAILURE";
//
export const OPEN_BLOG_ADD_MODAL = "app/LocationBlogs/OPEN_BLOG_ADD_MODAL";
export const CLOSE_BLOG_ADD_MODAL = "app/LocationBlogs/CLOSE_BLOG_ADD_MODAL";

export const OPEN_BLOG_EDIT_MODAL = "app/LocationBlogs/OPEN_BLOG_EDIT_MODAL";
export const CLOSE_BLOG_EDIT_MODAL = "app/LocationBlogs/CLOSE_BLOG_EDIT_MODAL";
export const SET_BLOG_SUCCESS = "app/LocationBlogs/SET_BLOG_SUCCESS";
export const SET_BLOG_FAILURE = "app/LocationBlogs/SET_BLOG_FAILURE";
